import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import CardComponent from '../components/CardComponent';
import DoughnutChartComponent from "../components/DoughnutChartComponent";
import { getDashboardLoading, getWidgetData, getWidgetsList, getUserWidgetsList } from "../selector/selectors";
import { loadWidgetsData, loadWidgetsList, saveUserWidgetsData,loggedUserWidgetsData,deleteUserWidgetsData } from "../api/dashboardapi";
import LoaderComponent from "../components/LoaderComponent";
import DashboardUsers from "../components/DashboardUsers";
import { Divider, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import {Box, Button, Drawer, List, ListItem,ListItemText, ListItemIcon} from "@mui/material";
import  { WidthProvider, Responsive } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import CloseIcon from '@mui/icons-material/Close';
import swal from "sweetalert";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import OktaAuth from "@okta/okta-auth-js";
// import configData from "../config.json";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

function Dashboard({isLoading,widgetData, startLoadingWidgetData,widgetsList,startLoadingWidgetsList,saveDashboardData,userDashboardData,userWidgetsList,deleteUserWidget}) {

  const [open, setOpen] = React.useState(false);
  const [layouts, setLayouts] = useState(null);
  const [widgetArray, setWidgetArray] = useState([]);
  const [active,setActive] = useState({});
  const [disabled, setDisabled] = useState([]);
  const [openElem, setOpenElem] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [drawer, setDrawer] = React.useState(false);

  const handleClickMenu = (itemId) => (event) => {
    setAnchorEl(event.currentTarget);
    setOpenElem(itemId);
  };
  
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenElem(null);
  };

  const handleDrawerOpen = () => {
    setDrawer(true)
    setOpen(true);
  };

  const handleDrawerIconClick = () => {
    setDrawer(true)
    setOpen(false);
  };

  const handleClick = (widget) => {
    if(disabled.indexOf(widget.id) <= -1){
      setActive({
        'id':widget.id,
        'name':widget.widget_name
      });
    }
  }

  useEffect(() => {
    startLoadingWidgetsList();
    userDashboardData();
    // eslint-disable-next-line
  }, []);


  const handleModify = (layouts, layout) => {
    const tempArray = widgetArray;
    setLayouts(layout);
    layouts?.map((position) => {
      tempArray[Number(position.i)].x = position.x;
      tempArray[Number(position.i)].y = position.y;
      tempArray[Number(position.i)].w = position.w;
      tempArray[Number(position.i)].h = position.h;
      return tempArray;
    });
    setWidgetArray(tempArray);
  };

  const handleAddWidget =  () => {
    if(active.id){
      startLoadingWidgetData(active.id); 
    } 
  };

  useEffect(() => {
    let w = 2;
    let h = 2;
    if(widgetData.length !== 0 && active?.id){
      setWidgetArray([
        ...widgetArray,
        { i: "widget" + (widgetArray.length + 1), x: 0, y: (widgetsList.length * 2), w: w, h: h, 'id': active.id, 'name': active.name, 'data': widgetData },
      ]);
      setDisabled([...disabled,active.id])
      setActive('');
    }
    // eslint-disable-next-line
  }, [widgetData]);


  useEffect(() => {
    if(userWidgetsList?.layout){
      let userWidgetsListArray = userWidgetsList.layout;
      setWidgetArray(userWidgetsListArray);
      let disabledIds = userWidgetsListArray.map(item => item.id);
      setDisabled(disabledIds)
    }
  }, [userWidgetsList]);


  const removeElement = (event,item,type=0) => {
    handleCloseMenu();
    swal({
      title: "Delete Widget",
      text: 'Are you sure you want to delete this widget?',
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      closeOnClickOutside: false,
      closeOnEsc: false,
      allowOutsideClick: false,
    }).then(async willDelete => {
      if (willDelete) {
        if(type === 1){
          deleteUserWidget(item.id)
        }
        const tempArray = widgetArray.slice();
        const index = tempArray.indexOf(tempArray.find((data) => data.id === item.id));
        tempArray.splice(index, 1);
        console.log('tempArray',tempArray)
        setWidgetArray(tempArray);
        setDisabled(disabled.filter(i => i !== item.id))
      }
    });   
  }

  const handleSaveDashboard = () => {
    setActive('');
    setOpen(false);
    setDrawer(false)
    saveDashboardData(widgetArray);
  };


  return (
    <Box sx={{ flexGrow: 1,pt:1 }} >
      { isLoading?<LoaderComponent />:<></> }  
      
        {!open && !drawer &&
        <Button className="dashboardButtons" style={{ marginLeft:'20px' }} variant="contained" color="primary"  onClick={handleDrawerOpen}>Edit Dashboard</Button>
        }
        
        {(open || drawer) &&
        <Button className="dashboardButtons" style={{ marginLeft:'20px' }} variant="contained" color="primary"  onClick={handleSaveDashboard}>Save Changes</Button>
        }
      
      <Drawer sx={{ 
          "& .MuiDrawer-paper": {
              top: '64px'
          }
        }} anchor="right" open={open}  variant="persistent">
        <Box
          sx={{ width: 350}}
          role="presentation"
        >
          <List>
            <ListItem sx={{pt:3,pb:3}}>
              <Typography variant="h6"  color="text.secondary">
                Add Widget
              </Typography>
              <IconButton onClick={handleDrawerIconClick}><ChevronRightIcon /></IconButton>
            </ListItem> 
            
            <Divider />
            { widgetsList?.map((widget) => {
              return (
                <>
                  <ListItem 
                    onClick={(e) => {handleClick(widget)}}
                    sx={{background:'#F9F9F9',cursor:'pointer'}} 
                    key={widget.id}
                    className={active.id === widget.id ? "activeWidget" : disabled.indexOf(widget.id) > -1 ? "disabledWidget" : ""}
                  >
                    <ListItemText>Widget - {widget.widget_name}</ListItemText>
                  </ListItem>
                  <Divider />
                </>
              )
            })}
          </List>
          <Button sx={{m:2}} variant="contained" color="primary"  onClick={handleAddWidget}> Add</Button>
        </Box>  
      </Drawer>
      <ResponsiveReactGridLayout
        className="layout"
        onLayoutChange={handleModify}
        verticalCompact={true}
        layout={layouts}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        preventCollision={false}
        cols={{ lg: 8, md: 8, sm: 4, xs: 2, xxs: 2 }}
        margin={{
          lg: [20, 20],
          md: [20, 20],
          sm: [20, 20],
          xs: [20, 20],
          xxs: [20, 20],
        }}
      >
         {widgetArray?.length > 0 && widgetArray?.map((item,index) => (
          <div 
            className="reactGridItem"
            key={index}
            data-grid={{  
              x: item?.x,
              y: item?.y,
              w: item?.w,
              h: item?.h,
              i: item.i,
              minW: 1,
              maxW: Infinity,
              minH: 1,
              maxH: Infinity,
              isDraggable: (open || drawer) ? true : false,
              isResizable: (open || drawer) ? true : false
            }}
          >
            {(open || drawer) &&
              <CloseIcon 
                fontSize='small' 
                onMouseDown={(e) => e.stopPropagation() } 
                onClick={(event) => removeElement(event,item)} 
                className="deleteDashboardButton"
                >
                </CloseIcon>
            }
            {!open && !drawer && 
              <div key={item.id}>
               <IconButton  
                aria-label="more"
                aria-controls={"long-menu" + item.id}
                aria-haspopup="true"
                onClick={handleClickMenu(item.id)}
                fontSize='small'
                className="deleteDashboardButton"
              >
                <MoreHorizIcon />
              </IconButton> 
               <Menu
                  id={"long-menu" + item.id}
                  open={openElem === item.id}
                  anchorEl={anchorEl}
                  onClose={handleCloseMenu}
                  keepMounted
                  style={{
                    maxHeight: 40 * 4.5,
                    width: '20ch',
                  }}
                >  
                  <MenuItem
                   //value={item.id}
                   onClick={(event)=> removeElement(event,item,1)} 
                  >
                    <ListItemIcon><CloseIcon fontSize="small"></CloseIcon></ListItemIcon>
                    <ListItemText> Delete </ListItemText>
                  </MenuItem> 
                 </Menu></div>
            }
            {(item.id === 1 || item.id === 2 ||  item.id === 3 || item.id === 4)  &&
                <CardComponent title={item.name}  data={item.data} />
            }
            {item.id === 5 &&
                <DoughnutChartComponent doughnutData={item.data} /> 
            }
            {item.id === 6 &&
                <DashboardUsers usersList={item.data} />
            }
          </div>
        ))}  
      </ResponsiveReactGridLayout>  
    </Box>
  );
}

const mapStateToProps = (state) => ({
  isLoading:        getDashboardLoading(state),  
  widgetData:       getWidgetData(state),  
  widgetsList:      getWidgetsList(state),
  userWidgetsList:  getUserWidgetsList(state),
});
const mapDispatchToProps = (dispatch) => ({
  startLoadingWidgetsList: () => dispatch(loadWidgetsList()),
  startLoadingWidgetData: (id) => dispatch(loadWidgetsData(id)),
  saveDashboardData: (data) => dispatch(saveUserWidgetsData(data)),
  userDashboardData: () => dispatch(loggedUserWidgetsData()),
  deleteUserWidget: (widgetId) => dispatch(deleteUserWidgetsData(widgetId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);

